import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { trackCta } from '../analytics';
import BookDemoButton from './BookDemoButton';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const appBaseUrl = process.env.REACT_APP_APP_URL || 'https://app.pycrust.io';
  const loginUrl = `${appBaseUrl}/login`;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!isMenuOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isMenuOpen]);

  const handleLogoClick = () => {
    setIsMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Main Header */}
      <header className={`header${isScrolled ? ' scrolled' : ''}`}>
        <div className="container">
          <nav className="nav">
            <div className="nav-brand">
              <Link to="/" onClick={handleLogoClick}>
                <img
                  src="/branding/pycrust-logo.png"
                  alt="Pycrust logo"
                  className="nav-brand-logo"
                />
              </Link>
            </div>

            <div
              id="primary-navigation"
              className={`nav-menu ${isMenuOpen ? 'active' : ''}`}
            >
              <Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link>
              <Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</Link>
              <Link to="/features" onClick={() => setIsMenuOpen(false)}>Features</Link>
              <BookDemoButton
                placement="header_nav"
                variant="nav"
                onPress={() => setIsMenuOpen(false)}
              />
              <a
                href={loginUrl}
                className="login-btn"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackCta('login_signup', 'header_nav')}
              >
                Login / Sign Up
              </a>
            </div>

            <button
              type="button"
              className="nav-toggle"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-expanded={isMenuOpen}
              aria-controls="primary-navigation"
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            >
              {isMenuOpen ? <X size="1.5rem" aria-hidden /> : <Menu size="1.5rem" aria-hidden />}
            </button>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
